import React from "react";
import { Column } from "react-data-grid";
import {
  CustomerPortalIntervention,
  InterventionTableQuery,
} from "../../../interventions/models";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import { Table } from "../../../../components";
import { getTablePageCount } from "../../../../helpers/tableHelpers";
import { renderDate } from "../../../../helpers/dayjsHeleprs";
import { useNavigate } from "../../../../helpers/navigationHelpers";

interface Props {
  queryParams: InterventionTableQuery;
  setQueryParams: (queryParams: InterventionTableQuery) => void;
  data: CustomerPortalIntervention[];
  isLoading: boolean;
  total: number;
}

const HomeInterventionsTable: React.FC<Props> = (props): React.ReactElement => {
  const { tIntervention, tOrder } = useCustomTranslation();
  const navigate = useNavigate();

  const columns: Column<CustomerPortalIntervention>[] = [
    {
      key: "orderCode",
      name: tOrder("code"),
      sortable: true,
    },
    {
      key: "day",
      name: tIntervention("day"),
      renderCell: (props) => renderDate(props.row.day),
      sortable: true,
    },
    {
      key: "categoryName",
      name: tIntervention("category"),
      sortable: true,
    },
    {
      key: "primaryAssigneeName",
      name: tIntervention("primaryAssignee"),
      sortable: true,
    },
  ];

  return (
    <Table
      columns={columns}
      data={props.data}
      loading={props.isLoading}
      queryParams={props.queryParams}
      onTableQueryChange={props.setQueryParams}
      pageCount={getTablePageCount(props.total, props.queryParams.pageSize)}
      onRowClick={(item) => navigate.goTo(`orders/${item.orderId}`)}
    />
  );
};

export default HomeInterventionsTable;
